import { render, staticRenderFns } from "./ListagemOcorrencia.vue?vue&type=template&id=858a4aae&scoped=true&"
import script from "./ListagemOcorrencia.vue?vue&type=script&lang=js&"
export * from "./ListagemOcorrencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858a4aae",
  null
  
)

export default component.exports